const GET_BUMEX_FEATURE_BULK = 'core/bumexFeature/GET_BUMEX_FEATURE_BULK';
const GET_BUMEX_FEATURE_BULK_COMPLETED = 'core/bumexFeature/GET_BUMEX_FEATURE_BULK_COMPLETED';
const GET_BUMEX_FEATURE_BULK_FAILED = 'core/bumexFeature/GET_BUMEX_FEATURE_BULK_FAILED';
const GET_BUMEX_FEATURE = 'core/bumexFeature/GET_BUMEX_FEATURE';
const GET_BUMEX_FEATURE_COMPLETED = 'core/bumexFeature/GET_BUMEX_FEATURE_COMPLETED';
const GET_BUMEX_FEATURE_FAILED = 'core/bumexFeature/GET_BUMEX_FEATURE_FAILED';

export {
  GET_BUMEX_FEATURE_BULK,
  GET_BUMEX_FEATURE_BULK_COMPLETED,
  GET_BUMEX_FEATURE_BULK_FAILED,
  GET_BUMEX_FEATURE,
  GET_BUMEX_FEATURE_COMPLETED,
  GET_BUMEX_FEATURE_FAILED
};
